import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import AppWithAuth from './AppWithAuth';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { AuthProvider } from './auth/AuthContext';
import { auth0ProviderConfig, isAuth0Configured } from './auth/auth0Config';

// Ensure Auth0 is properly configured
if (!isAuth0Configured()) {
  console.error('Auth0 configuration is missing or incomplete. Please check your environment variables.');
}

// Handle redirect after Auth0 login
const onRedirectCallback = (appState?: any) => {
  const url = appState?.returnTo || window.location.pathname;
  window.history.replaceState({}, document.title, url);
};

const auth0ConfigWithCallback = {
  ...auth0ProviderConfig,
  onRedirectCallback
};

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Auth0Provider {...auth0ConfigWithCallback}>
          <AuthProvider>
            <AppWithAuth />
          </AuthProvider>
        </Auth0Provider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
